var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _g, _rect21, _rect22, _rect23, _rect24, _rect25, _rect26, _rect27, _rect28, _rect29, _rect30, _rect31, _rect32, _rect33, _rect34, _rect35, _rect36, _g2, _rect37, _rect38, _rect39, _rect40, _rect41, _rect42, _rect43, _rect44, _rect45, _rect46, _rect47, _rect48, _rect49, _g3, _rect50, _rect51, _rect52, _rect53, _rect54, _rect55, _rect56, _rect57, _rect58, _rect59, _rect60, _rect61, _rect62, _rect63, _rect64, _rect65, _rect66, _rect67, _rect68, _rect69, _rect70, _rect71, _path, _path2, _path3, _path4, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEasyIntegration(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 601,
    height: 525,
    viewBox: "0 0 601 525",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 125,
    width: 2,
    height: 525,
    fill: "url(#paint0_linear_59_506)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 74,
    width: 2,
    height: 525,
    fill: "url(#paint1_linear_59_506)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 175,
    width: 2,
    height: 525,
    fill: "url(#paint2_linear_59_506)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 225,
    width: 2,
    height: 525,
    fill: "url(#paint3_linear_59_506)"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 275,
    width: 2,
    height: 525,
    fill: "url(#paint4_linear_59_506)"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 325,
    width: 2,
    height: 525,
    fill: "url(#paint5_linear_59_506)"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 375,
    width: 2,
    height: 525,
    fill: "url(#paint6_linear_59_506)"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 425,
    width: 2,
    height: 525,
    fill: "url(#paint7_linear_59_506)"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 475,
    width: 2,
    height: 525,
    fill: "url(#paint8_linear_59_506)"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 525,
    width: 2,
    height: 525,
    fill: "url(#paint9_linear_59_506)"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 601,
    y: 87,
    width: 2,
    height: 601,
    transform: "rotate(90 601 87)",
    fill: "url(#paint10_linear_59_506)"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 601,
    y: 36,
    width: 2,
    height: 601,
    transform: "rotate(90 601 36)",
    fill: "url(#paint11_linear_59_506)"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 601,
    y: 137,
    width: 2,
    height: 601,
    transform: "rotate(90 601 137)",
    fill: "url(#paint12_linear_59_506)"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 601,
    y: 187,
    width: 2,
    height: 601,
    transform: "rotate(90 601 187)",
    fill: "url(#paint13_linear_59_506)"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 601,
    y: 237,
    width: 2,
    height: 601,
    transform: "rotate(90 601 237)",
    fill: "url(#paint14_linear_59_506)"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 601,
    y: 287,
    width: 2,
    height: 601,
    transform: "rotate(90 601 287)",
    fill: "url(#paint15_linear_59_506)"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 601,
    y: 337,
    width: 2,
    height: 601,
    transform: "rotate(90 601 337)",
    fill: "url(#paint16_linear_59_506)"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 601,
    y: 387,
    width: 2,
    height: 601,
    transform: "rotate(90 601 387)",
    fill: "url(#paint17_linear_59_506)"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 601,
    y: 437,
    width: 2,
    height: 601,
    transform: "rotate(90 601 437)",
    fill: "url(#paint18_linear_59_506)"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 601,
    y: 487,
    width: 2,
    height: 601,
    transform: "rotate(90 601 487)",
    fill: "url(#paint19_linear_59_506)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_59_506)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 88.0021,
    y: 58,
    width: 179.002,
    height: 179.002,
    rx: 3,
    fill: "white",
    fillOpacity: 0.05
  }))), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 108.966,
    y: 79.7705,
    width: 66.1179,
    height: 12.0947,
    rx: 3,
    fill: "white",
    fillOpacity: 0.05
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 108.966,
    y: 107.185,
    width: 21.5622,
    height: 12.0947,
    rx: 3,
    fill: "white",
    fillOpacity: 0.05
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 108.966,
    y: 131.375,
    width: 21.5622,
    height: 12.0947,
    rx: 3,
    fill: "white",
    fillOpacity: 0.05
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 108.966,
    y: 155.564,
    width: 21.5622,
    height: 12.0947,
    rx: 3,
    fill: "white",
    fillOpacity: 0.05
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 108.966,
    y: 179.754,
    width: 21.5622,
    height: 12.0947,
    rx: 3,
    fill: "white",
    fillOpacity: 0.05
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    x: 108.966,
    y: 203.943,
    width: 21.5622,
    height: 12.0947,
    rx: 3,
    fill: "white",
    fillOpacity: 0.05
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    x: 145.93,
    y: 107.185,
    width: 48.5149,
    height: 12.0947,
    rx: 3,
    fill: "white",
    fillOpacity: 0.05
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    x: 146.057,
    y: 131.375,
    width: 54.8295,
    height: 12.0947,
    rx: 3,
    fill: "white",
    fillOpacity: 0.05
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    x: 146.057,
    y: 155.564,
    width: 35.4779,
    height: 12.0947,
    rx: 3,
    fill: "white",
    fillOpacity: 0.05
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    x: 146.057,
    y: 179.754,
    width: 54.8295,
    height: 12.0947,
    rx: 3,
    fill: "white",
    fillOpacity: 0.05
  })), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    x: 145.93,
    y: 203.943,
    width: 48.5149,
    height: 12.0947,
    rx: 3,
    fill: "white",
    fillOpacity: 0.05
  })), _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
    x: 209.846,
    y: 107.185,
    width: 36.1936,
    height: 12.0947,
    rx: 3,
    fill: "white",
    fillOpacity: 0.05
  })), _rect33 || (_rect33 = /*#__PURE__*/React.createElement("rect", {
    x: 216.206,
    y: 131.375,
    width: 29.8337,
    height: 12.0947,
    rx: 3,
    fill: "white",
    fillOpacity: 0.05
  })), _rect34 || (_rect34 = /*#__PURE__*/React.createElement("rect", {
    x: 196.855,
    y: 155.564,
    width: 49.1853,
    height: 12.0947,
    rx: 3,
    fill: "white",
    fillOpacity: 0.05
  })), _rect35 || (_rect35 = /*#__PURE__*/React.createElement("rect", {
    x: 216.206,
    y: 179.754,
    width: 29.8337,
    height: 12.0947,
    rx: 3,
    fill: "white",
    fillOpacity: 0.05
  })), _rect36 || (_rect36 = /*#__PURE__*/React.createElement("rect", {
    x: 209.846,
    y: 203.943,
    width: 36.1936,
    height: 12.0947,
    rx: 3,
    fill: "white",
    fillOpacity: 0.05
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_b_59_506)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 104.935,
    y: 292.638,
    width: 179.002,
    height: 151.587,
    rx: 3,
    fill: "white",
    fillOpacity: 0.05
  }))), _rect37 || (_rect37 = /*#__PURE__*/React.createElement("rect", {
    x: 125.899,
    y: 314.408,
    width: 89.5011,
    height: 12.0947,
    rx: 3,
    fill: "white",
    fillOpacity: 0.05
  })), _rect38 || (_rect38 = /*#__PURE__*/React.createElement("rect", {
    x: 125.899,
    y: 341.823,
    width: 21.5622,
    height: 12.0947,
    rx: 3,
    fill: "white",
    fillOpacity: 0.05
  })), _rect39 || (_rect39 = /*#__PURE__*/React.createElement("rect", {
    x: 125.899,
    y: 366.013,
    width: 21.5622,
    height: 12.0947,
    rx: 3,
    fill: "white",
    fillOpacity: 0.05
  })), _rect40 || (_rect40 = /*#__PURE__*/React.createElement("rect", {
    x: 125.899,
    y: 390.202,
    width: 21.5622,
    height: 12.0947,
    rx: 3,
    fill: "white",
    fillOpacity: 0.05
  })), _rect41 || (_rect41 = /*#__PURE__*/React.createElement("rect", {
    x: 125.899,
    y: 414.392,
    width: 21.5622,
    height: 12.0947,
    rx: 3,
    fill: "white",
    fillOpacity: 0.05
  })), _rect42 || (_rect42 = /*#__PURE__*/React.createElement("rect", {
    x: 162.863,
    y: 341.823,
    width: 48.5149,
    height: 12.0947,
    rx: 3,
    fill: "white",
    fillOpacity: 0.05
  })), _rect43 || (_rect43 = /*#__PURE__*/React.createElement("rect", {
    x: 162.99,
    y: 366.013,
    width: 54.8295,
    height: 12.0947,
    rx: 3,
    fill: "white",
    fillOpacity: 0.05
  })), _rect44 || (_rect44 = /*#__PURE__*/React.createElement("rect", {
    x: 162.99,
    y: 390.202,
    width: 35.4779,
    height: 12.0947,
    rx: 3,
    fill: "white",
    fillOpacity: 0.05
  })), _rect45 || (_rect45 = /*#__PURE__*/React.createElement("rect", {
    x: 162.99,
    y: 414.392,
    width: 54.8295,
    height: 12.0947,
    rx: 3,
    fill: "white",
    fillOpacity: 0.05
  })), _rect46 || (_rect46 = /*#__PURE__*/React.createElement("rect", {
    x: 226.779,
    y: 341.823,
    width: 36.1936,
    height: 12.0947,
    rx: 3,
    fill: "white",
    fillOpacity: 0.05
  })), _rect47 || (_rect47 = /*#__PURE__*/React.createElement("rect", {
    x: 233.139,
    y: 366.013,
    width: 29.8337,
    height: 12.0947,
    rx: 3,
    fill: "white",
    fillOpacity: 0.05
  })), _rect48 || (_rect48 = /*#__PURE__*/React.createElement("rect", {
    x: 213.787,
    y: 390.202,
    width: 49.1853,
    height: 12.0947,
    rx: 3,
    fill: "white",
    fillOpacity: 0.05
  })), _rect49 || (_rect49 = /*#__PURE__*/React.createElement("rect", {
    x: 233.139,
    y: 414.392,
    width: 29.8337,
    height: 12.0947,
    rx: 3,
    fill: "white",
    fillOpacity: 0.05
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_b_59_506)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 316.996,
    y: 169,
    width: 179.002,
    height: 226.575,
    rx: 3,
    fill: "white",
    fillOpacity: 0.05
  }))), _rect50 || (_rect50 = /*#__PURE__*/React.createElement("rect", {
    x: 337.96,
    y: 190.771,
    width: 45.1537,
    height: 12.0947,
    rx: 3,
    fill: "white",
    fillOpacity: 0.05
  })), _rect51 || (_rect51 = /*#__PURE__*/React.createElement("rect", {
    x: 337.96,
    y: 266.564,
    width: 21.5622,
    height: 12.0947,
    rx: 3,
    fill: "white",
    fillOpacity: 0.05
  })), _rect52 || (_rect52 = /*#__PURE__*/React.createElement("rect", {
    x: 374.924,
    y: 266.564,
    width: 48.5149,
    height: 12.0947,
    rx: 3,
    fill: "white",
    fillOpacity: 0.05
  })), _rect53 || (_rect53 = /*#__PURE__*/React.createElement("rect", {
    x: 438.84,
    y: 266.564,
    width: 36.1936,
    height: 12.0947,
    rx: 3,
    fill: "white",
    fillOpacity: 0.05
  })), _rect54 || (_rect54 = /*#__PURE__*/React.createElement("rect", {
    x: 337.96,
    y: 290.754,
    width: 21.5622,
    height: 12.0947,
    rx: 3,
    fill: "white",
    fillOpacity: 0.05
  })), _rect55 || (_rect55 = /*#__PURE__*/React.createElement("rect", {
    x: 375.051,
    y: 290.754,
    width: 54.8295,
    height: 12.0947,
    rx: 3,
    fill: "white",
    fillOpacity: 0.05
  })), _rect56 || (_rect56 = /*#__PURE__*/React.createElement("rect", {
    x: 445.2,
    y: 290.754,
    width: 29.8337,
    height: 12.0947,
    rx: 3,
    fill: "white",
    fillOpacity: 0.05
  })), _rect57 || (_rect57 = /*#__PURE__*/React.createElement("rect", {
    x: 337.96,
    y: 339.133,
    width: 21.5622,
    height: 12.0947,
    rx: 3,
    fill: "white",
    fillOpacity: 0.05
  })), _rect58 || (_rect58 = /*#__PURE__*/React.createElement("rect", {
    x: 375.051,
    y: 339.133,
    width: 54.8295,
    height: 12.0947,
    rx: 3,
    fill: "white",
    fillOpacity: 0.05
  })), _rect59 || (_rect59 = /*#__PURE__*/React.createElement("rect", {
    x: 445.2,
    y: 339.133,
    width: 29.8337,
    height: 12.0947,
    rx: 3,
    fill: "white",
    fillOpacity: 0.05
  })), _rect60 || (_rect60 = /*#__PURE__*/React.createElement("rect", {
    x: 337.96,
    y: 314.943,
    width: 21.5622,
    height: 12.0947,
    rx: 3,
    fill: "white",
    fillOpacity: 0.05
  })), _rect61 || (_rect61 = /*#__PURE__*/React.createElement("rect", {
    x: 375.051,
    y: 314.943,
    width: 35.4779,
    height: 12.0947,
    rx: 3,
    fill: "white",
    fillOpacity: 0.05
  })), _rect62 || (_rect62 = /*#__PURE__*/React.createElement("rect", {
    x: 425.849,
    y: 314.943,
    width: 49.1853,
    height: 12.0947,
    rx: 3,
    fill: "white",
    fillOpacity: 0.05
  })), _rect63 || (_rect63 = /*#__PURE__*/React.createElement("rect", {
    x: 337.96,
    y: 242.375,
    width: 21.5622,
    height: 12.0947,
    rx: 3,
    fill: "white",
    fillOpacity: 0.05
  })), _rect64 || (_rect64 = /*#__PURE__*/React.createElement("rect", {
    x: 375.051,
    y: 242.375,
    width: 54.8295,
    height: 12.0947,
    rx: 3,
    fill: "white",
    fillOpacity: 0.05
  })), _rect65 || (_rect65 = /*#__PURE__*/React.createElement("rect", {
    x: 445.2,
    y: 242.375,
    width: 29.8337,
    height: 12.0947,
    rx: 3,
    fill: "white",
    fillOpacity: 0.05
  })), _rect66 || (_rect66 = /*#__PURE__*/React.createElement("rect", {
    x: 337.96,
    y: 218.185,
    width: 21.5622,
    height: 12.0947,
    rx: 3,
    fill: "white",
    fillOpacity: 0.05
  })), _rect67 || (_rect67 = /*#__PURE__*/React.createElement("rect", {
    x: 374.924,
    y: 218.185,
    width: 48.5149,
    height: 12.0947,
    rx: 3,
    fill: "white",
    fillOpacity: 0.05
  })), _rect68 || (_rect68 = /*#__PURE__*/React.createElement("rect", {
    x: 438.84,
    y: 218.185,
    width: 36.1936,
    height: 12.0947,
    rx: 3,
    fill: "white",
    fillOpacity: 0.05
  })), _rect69 || (_rect69 = /*#__PURE__*/React.createElement("rect", {
    x: 337.96,
    y: 363.322,
    width: 21.5622,
    height: 12.0947,
    rx: 3,
    fill: "white",
    fillOpacity: 0.05
  })), _rect70 || (_rect70 = /*#__PURE__*/React.createElement("rect", {
    x: 374.924,
    y: 363.322,
    width: 48.5149,
    height: 12.0947,
    rx: 3,
    fill: "white",
    fillOpacity: 0.05
  })), _rect71 || (_rect71 = /*#__PURE__*/React.createElement("rect", {
    x: 438.84,
    y: 363.322,
    width: 36.1936,
    height: 12.0947,
    rx: 3,
    fill: "white",
    fillOpacity: 0.05
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M267.004 143.001C264.504 143.001 262.504 145.001 262.504 147.501C262.504 150.001 264.504 152.001 267.004 152.001C269.504 152.001 271.504 150.001 271.504 147.501C271.504 145.001 269.504 143.001 267.004 143.001Z",
    fill: "#6016FC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M264.004 147.501C264.004 145.829 265.333 144.501 267.004 144.501V141.501C263.676 141.501 261.004 144.173 261.004 147.501H264.004ZM267.004 144.501C268.676 144.501 270.004 145.829 270.004 147.501H273.004C273.004 144.173 270.333 141.501 267.004 141.501V144.501ZM270.004 147.501C270.004 149.173 268.676 150.501 267.004 150.501V153.501C270.333 153.501 273.004 150.829 273.004 147.501H270.004ZM267.004 150.501C265.333 150.501 264.004 149.173 264.004 147.501H261.004C261.004 150.829 263.676 153.501 267.004 153.501V150.501ZM271.504 149.001H386.497V146.001H271.504V149.001ZM404.997 167.501V169H407.997V167.501H404.997ZM386.497 149.001C396.714 149.001 404.997 157.284 404.997 167.501H407.997C407.997 155.627 398.371 146.001 386.497 146.001V149.001Z",
    fill: "#222234"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M283.937 363.932C281.437 363.932 279.437 365.932 279.437 368.432C279.437 370.932 281.437 372.932 283.937 372.932C286.437 372.932 288.437 370.932 288.437 368.432C288.437 365.932 286.437 363.932 283.937 363.932Z",
    fill: "#6016FC"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M280.937 368.432C280.937 366.76 282.265 365.432 283.937 365.432V362.432C280.608 362.432 277.937 365.103 277.937 368.432H280.937ZM283.937 365.432C285.608 365.432 286.937 366.76 286.937 368.432H289.937C289.937 365.103 287.265 362.432 283.937 362.432V365.432ZM286.937 368.432C286.937 370.103 285.608 371.432 283.937 371.432V374.432C287.265 374.432 289.937 371.76 289.937 368.432H286.937ZM283.937 371.432C282.265 371.432 280.937 370.103 280.937 368.432H277.937C277.937 371.76 280.608 374.432 283.937 374.432V371.432ZM301.966 356.402V298.817H298.966V356.402H301.966ZM301.966 298.817C301.966 290.516 308.695 283.787 316.996 283.787V280.787C307.038 280.787 298.966 288.859 298.966 298.817H301.966ZM288.437 369.932C295.909 369.932 301.966 363.874 301.966 356.402H298.966C298.966 362.217 294.252 366.932 288.437 366.932V369.932Z",
    fill: "#222234"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_59_506",
    x: 14.0021,
    y: -16,
    width: 327.002,
    height: 327.002,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImage",
    stdDeviation: 37
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_59_506"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_59_506",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_b_59_506",
    x: 30.9348,
    y: 218.638,
    width: 327.002,
    height: 299.587,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImage",
    stdDeviation: 37
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_59_506"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_59_506",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_b_59_506",
    x: 242.996,
    y: 95,
    width: 327.002,
    height: 374.575,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImage",
    stdDeviation: 37
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_59_506"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_59_506",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_59_506",
    x1: 126,
    y1: 0,
    x2: 126,
    y2: 525,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.479167,
    stopColor: "white",
    stopOpacity: 0.02
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.994792,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_59_506",
    x1: 75,
    y1: 0,
    x2: 75,
    y2: 525,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.479167,
    stopColor: "white",
    stopOpacity: 0.02
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.994792,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_59_506",
    x1: 176,
    y1: 0,
    x2: 176,
    y2: 525,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.479167,
    stopColor: "white",
    stopOpacity: 0.02
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.994792,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_59_506",
    x1: 226,
    y1: 0,
    x2: 226,
    y2: 525,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.479167,
    stopColor: "white",
    stopOpacity: 0.02
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.994792,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_59_506",
    x1: 276,
    y1: 0,
    x2: 276,
    y2: 525,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.479167,
    stopColor: "white",
    stopOpacity: 0.02
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.994792,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_59_506",
    x1: 326,
    y1: 0,
    x2: 326,
    y2: 525,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.479167,
    stopColor: "white",
    stopOpacity: 0.02
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.994792,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_59_506",
    x1: 376,
    y1: 0,
    x2: 376,
    y2: 525,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.479167,
    stopColor: "white",
    stopOpacity: 0.02
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.994792,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_59_506",
    x1: 426,
    y1: 0,
    x2: 426,
    y2: 525,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.479167,
    stopColor: "white",
    stopOpacity: 0.02
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.994792,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_59_506",
    x1: 476,
    y1: 0,
    x2: 476,
    y2: 525,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.479167,
    stopColor: "white",
    stopOpacity: 0.02
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.994792,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_59_506",
    x1: 526,
    y1: 0,
    x2: 526,
    y2: 525,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.479167,
    stopColor: "white",
    stopOpacity: 0.02
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.994792,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_59_506",
    x1: 602,
    y1: 87,
    x2: 602,
    y2: 688,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.479167,
    stopColor: "white",
    stopOpacity: 0.02
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.994792,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_59_506",
    x1: 602,
    y1: 36,
    x2: 602,
    y2: 637,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.479167,
    stopColor: "white",
    stopOpacity: 0.02
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.994792,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_59_506",
    x1: 602,
    y1: 137,
    x2: 602,
    y2: 738,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.479167,
    stopColor: "white",
    stopOpacity: 0.02
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.994792,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_59_506",
    x1: 602,
    y1: 187,
    x2: 602,
    y2: 788,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.479167,
    stopColor: "white",
    stopOpacity: 0.02
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.994792,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_59_506",
    x1: 602,
    y1: 237,
    x2: 602,
    y2: 838,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.479167,
    stopColor: "white",
    stopOpacity: 0.02
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.994792,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_59_506",
    x1: 602,
    y1: 287,
    x2: 602,
    y2: 888,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.479167,
    stopColor: "white",
    stopOpacity: 0.02
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.994792,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_59_506",
    x1: 602,
    y1: 337,
    x2: 602,
    y2: 938,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.479167,
    stopColor: "white",
    stopOpacity: 0.02
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.994792,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_59_506",
    x1: 602,
    y1: 387,
    x2: 602,
    y2: 988,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.479167,
    stopColor: "white",
    stopOpacity: 0.02
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.994792,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_59_506",
    x1: 602,
    y1: 437,
    x2: 602,
    y2: 1038,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.479167,
    stopColor: "white",
    stopOpacity: 0.02
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.994792,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_59_506",
    x1: 602,
    y1: 487,
    x2: 602,
    y2: 1088,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.479167,
    stopColor: "white",
    stopOpacity: 0.02
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.994792,
    stopColor: "white",
    stopOpacity: 0
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEasyIntegration);
export default __webpack_public_path__ + "static/media/easyIntegration.44ddfdbd8a7f8613ccd64375c87ef57f.svg";
export { ForwardRef as ReactComponent };